const getContentReader = bundle => key =>
  bundle?.[`${key}${window.UI_ENV === "prod" ? "" : "Non"}Prod`] ?? bundle?.[key] ?? "";

export default getContentReader;
